!function (t, _) {
  "object" == typeof exports && "object" == typeof module ? module.exports = _() : "function" == typeof define && define.amd ? define("aws_amplify_ui", [], _) : "object" == typeof exports ? exports.aws_amplify_ui = _() : t.aws_amplify_ui = _();
}(this, function () {
  return function (t) {
    var _ = {};

    function n(o) {
      if (_[o]) return _[o].exports;
      var e = _[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
    }

    return n.m = t, n.c = _, n.d = function (t, _, o) {
      n.o(t, _) || Object.defineProperty(t, _, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, _) {
      if (1 & _ && (t = n(t)), 8 & _) return t;
      if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & _ && "string" != typeof t) for (var e in t) {
        n.d(o, e, function (_) {
          return t[_];
        }.bind(null, e));
      }
      return o;
    }, n.n = function (t) {
      var _ = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };

      return n.d(_, "a", _), _;
    }, n.o = function (t, _) {
      return Object.prototype.hasOwnProperty.call(t, _);
    }, n.p = "", n(n.s = 0);
  }([function (t, _, n) {
    "use strict";

    function o(t) {
      for (var n in t) {
        _.hasOwnProperty(n) || (_[n] = t[n]);
      }
    }

    Object.defineProperty(_, "__esModule", {
      value: !0
    }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
  }, function (t, _, n) {
    t.exports = {
      a: "Anchor__a___1_Iz8"
    };
  }, function (t, _, n) {
    t.exports = {
      button: "Button__button___vS7Mv",
      signInButton: "Button__signInButton___3bUH-",
      googleSignInButton: "Button__googleSignInButton___1YiCu",
      signInButtonIcon: "Button__signInButtonIcon___ihN75",
      auth0SignInButton: "Button__auth0SignInButton___znnCj",
      facebookSignInButton: "Button__facebookSignInButton___34Txh",
      amazonSignInButton: "Button__amazonSignInButton___2EMtl",
      oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
      signInButtonContent: "Button__signInButtonContent___xqTXJ"
    };
  }, function (t, _, n) {
    t.exports = {
      formContainer: "Form__formContainer___1GA3x",
      formSection: "Form__formSection___1PPvW",
      formField: "Form__formField___38Ikl",
      formRow: "Form__formRow___2mwRs"
    };
  }, function (t, _, n) {
    t.exports = {
      hint: "Hint__hint___2XngB"
    };
  }, function (t, _, n) {
    t.exports = {
      input: "Input__input___3e_bf",
      inputLabel: "Input__inputLabel___3VF0S",
      label: "Input__label___23sO8",
      radio: "Input__radio___2hllK"
    };
  }, function (t, _, n) {
    t.exports = {
      navBar: "Nav__navBar___xtCFA",
      navRight: "Nav__navRight___1QG2J",
      nav: "Nav__nav___2Dx2Y",
      navItem: "Nav__navItem___1LtFQ"
    };
  }, function (t, _, n) {
    t.exports = {
      photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
      photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
      photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
    };
  }, function (t, _, n) {
    t.exports = {
      container: "Section__container___3YYTG",
      actionRow: "Section__actionRow___2LWSU",
      sectionHeader: "Section__sectionHeader___2djyg",
      sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
      sectionBody: "Section__sectionBody___ihqqd",
      sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
      sectionFooter: "Section__sectionFooter___1T54C",
      sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
      sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
    };
  }, function (t, _, n) {
    t.exports = {
      selectInput: "SelectInput__selectInput___3efO4"
    };
  }, function (t, _, n) {
    t.exports = {
      strike: "Strike__strike___1XV1b",
      strikeContent: "Strike__strikeContent___10gLb"
    };
  }, function (t, _, n) {
    t.exports = {
      toast: "Toast__toast___XXr3v",
      toastClose: "Toast__toastClose___18lU4"
    };
  }, function (t, _, n) {
    t.exports = {
      totpQrcode: "Totp__totpQrcode___1crLx"
    };
  }, function (t, _, n) {
    t.exports = {
      sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
      sumerianScene: "XR__sumerianScene___2Tt7-",
      loadingOverlay: "XR__loadingOverlay___IbqcI",
      loadingContainer: "XR__loadingContainer___2Itxb",
      loadingLogo: "XR__loadingLogo___Ub7xQ",
      loadingSceneName: "XR__loadingSceneName___3__ne",
      loadingBar: "XR__loadingBar___2vcke",
      loadingBarFill: "XR__loadingBarFill___3M-D9",
      sceneErrorText: "XR__sceneErrorText___2y0tp",
      sceneBar: "XR__sceneBar___2ShrP",
      sceneName: "XR__sceneName___1ApHr",
      sceneActions: "XR__sceneActions___7plGs",
      actionButton: "XR__actionButton___2poIM",
      tooltip: "XR__tooltip___UYyhn",
      actionIcon: "XR__actionIcon___2qnd2",
      autoShowTooltip: "XR__autoShowTooltip___V1QH7"
    };
  }]);
});